import React from 'react';
import { Box, Typography } from '@mui/material';
import { chipStyles } from '../styles/configStyles';

export type SensitivityChipVariant = 'number' | 'smart-adaptive';

export type SensitivityChipProps = {
  label: string | number;
  selected: boolean;
  variant?: SensitivityChipVariant;
  disabled?: boolean;
  readonly?: boolean;
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const SensitivityChip: React.FC<SensitivityChipProps> = ({
  label,
  selected,
  variant = 'number',
  disabled = false,
  readonly = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  const inert = disabled || readonly;
  const handleClick = () => {
    if (!inert) onClick();
  };

  const chipSx =
    variant === 'smart-adaptive'
      ? chipStyles.smartAdaptiveChip(selected, disabled, readonly)
      : chipStyles.numberChip(selected, disabled, readonly);

  if (variant === 'smart-adaptive') {
    return (
      <Box
        data-testid="sensitivity-chip"
        data-variant="smart-adaptive"
        onClick={handleClick}
        onMouseEnter={!inert ? onMouseEnter : undefined}
        onMouseLeave={!inert ? onMouseLeave : undefined}
        sx={chipSx}
      >
        {label}
      </Box>
    );
  }

  return (
    <Box
      data-testid="sensitivity-chip"
      data-variant="number"
      onClick={handleClick}
      onMouseEnter={!inert ? onMouseEnter : undefined}
      onMouseLeave={!inert ? onMouseLeave : undefined}
      sx={chipStyles.chipContainer(disabled, readonly)}
    >
      <Box sx={chipSx}>
        <Typography sx={{ fontWeight: 500, fontSize: 14 }}>{label}</Typography>
      </Box>
    </Box>
  );
};

export default SensitivityChip;
